import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {Artifact} from "@webmate-web-core/shared/types/artifact";
import { faTimesCircle, faCheckCircle, faMinusCircle } from '@fortawesome/pro-solid-svg-icons';

@Component({
    selector: 'wm-contentanalysis-artifact',
    templateUrl: './contentanalysis-artifact.component.html',
    styleUrls: ['./contentanalysis-artifact.component.less']
})
export class ContentAnalysisArtifactComponent implements OnChanges {

    @Input() artifact?: Artifact;
    @Input() showStats: boolean = true;

    reportData: any;
    violations: any[];
    passes: any[];
    inapplicable: any[];
    
    stats: any;

    constructor() {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.artifact && this.artifact) {
            this.handleArtifact();
        }
    }

    handleArtifact() {
        if (!this.artifact) {
            return;
        }

        this.reportData = this.artifact.data.reportData;
        
        this.violations = this.reportData.axeResults?.violations || [];
        this.passes = this.reportData.axeResults?.passes || [];
        this.inapplicable = this.reportData.axeResults?.inapplicable || [];
        
        if (this.showStats) {
            this.computeStats();
        }
    }

    computeStats() {
        const violationStats = {
            critical: 0,
            serious: 0,
            moderate: 0,
            minor: 0,
            total: 0
        };

        this.violations?.forEach(violation => {
            if (violation.impact) {
                violationStats[violation.impact]++;
            }
            violationStats.total++;
        });

        const passesTotal = this.passes?.length || 0;
        const inapplicableTotal = this.inapplicable?.length || 0;
        const totalObservations = violationStats.total + passesTotal + inapplicableTotal;

        this.stats = {
            violation: violationStats,
            passes: { total: passesTotal },
            inapplicable: { total: inapplicableTotal },
            totalObservations
        };
    }

    protected readonly faTimesCircle = faTimesCircle;
    protected readonly faCheckCircle = faCheckCircle;
    protected readonly faMinusCircle = faMinusCircle;
}